export default "__VITE_ASSET__DzI7z1sK__"